/**
 * Centralized API configuration
 * Single source of truth for the backend API URL
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * Safe fetch wrapper that handles connection failures gracefully
 * Prevents ERR_CONNECTION_REFUSED from flooding the console
 */
export async function safeFetch(url, options = {}) {
    try {
        const response = await fetch(url, options);
        return response;
    } catch (error) {
        // Only log once, not spam the console
        if (error.name !== 'TypeError' || !error.message.includes('Failed to fetch')) {
            console.error('API request failed:', error);
        }
        throw error;
    }
}

/**
 * Helper to make authenticated requests
 */
export function authHeaders(additionalHeaders = {}) {
    const token = localStorage.getItem('authToken');
    return {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...additionalHeaders,
    };
}

export default API_BASE_URL;
